import React from 'react';
import { Link } from '@/navigation';
import {
  TypeLink_external,
  TypeLink_externalFields,
  TypeLink_internal,
  TypeLink_internalFields,
  TypeSubFooter,
} from '@/core/generated-types';
import { Entry } from 'contentful';
import { slugBuilder } from '@/core/contentfulConfig';

const FooterLegal = ({ fields }: TypeSubFooter) => {
  const { components: footerLinks, copyright } = fields;
  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <nav
      className="block bg-indigo px-8 py-4 text-white md:flex md:justify-between"
      data-testid="footer-legal"
    >
      <ul className="block">
        {footerLinks &&
          footerLinks.map(
            (
              link: Entry<TypeLink_externalFields | TypeLink_internalFields>,
            ) => {
              if (link.sys.contentType?.sys.id == 'link_internal') {
                const { linkText = '' } = link?.fields;

                return (
                  <li
                    className="list-none hover:underline md:inline-block md:pr-8"
                    key={link.sys?.id}
                  >
                    <Link
                      className="text-sm font-bold uppercase"
                      href={slugBuilder(link as TypeLink_internal)}
                    >
                      {linkText}
                    </Link>
                  </li>
                );
              } else {
                const { linkUrl = '/', linkText = '' } = (
                  link as TypeLink_external
                )?.fields;

                return (
                  <li
                    className="list-none hover:underline md:inline-block md:pr-8"
                    key={link.sys?.id}
                  >
                    <Link
                      className="text-sm font-bold uppercase"
                      href={linkUrl}
                    >
                      {linkText}
                    </Link>
                  </li>
                );
              }
            },
          )}
      </ul>
      <p className="text-base font-bold">
        <span>&#169;</span>
        {`${currentYear} ${copyright}`}
      </p>
    </nav>
  );
};

export default React.memo(FooterLegal);
